import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

const QuickCat = ({ options }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <>
      {options.map((option) => (
        <div className="border-top py-4" key={option.id}>
          <h4 className="mb-4">{option.title}</h4>
          <Field
            className="form-select"
            name={`quickCatSelections.${option.id}`}
            component="select"
            onChange={(event) => {
              const value = Number(event.target.value);

              setFieldValue(`quickCatSelections.${option.id}`, value);
            }}
          >
            {option.packageItems.map((item) => (
              <option value={item.id} key={item.id}>
                {item.title}
              </option>
            ))}
          </Field>
        </div>
      ))}
    </>
  );
};

QuickCat.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      packageItems: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          title: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default QuickCat;
